import { tpl } from '~/helpers/tpl';

export const query = tpl`
{
    shipdestruction: items(lang: "{{ languageCode }}", itemType: "shipdestruction", isCatalogue: true) {
        id
        title
        titleShort
        description
        tags
        typeName
        rarity
        icons {
            default
        }
        shipDestructionEffect {
            webm
        }
    }
}
`;
